export default function genererCritereRechercheConfrere() {
  return {
    auto: null,
    tiers: [],
    archive: false,
  };
}
